import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _typeof from '@babel/runtime/helpers/typeof';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import * as RTK from '@reduxjs/toolkit';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactRedux from 'react-redux';
import * as ReduxSaga from 'redux-saga';
import * as ReduxSagaEffects from 'redux-saga/effects';
import FastDeepEqualReact from 'fast-deep-equal/react';
import { LeUtils, ISSET, ARRAY, STRING, INT_LAX_ANY, IS_OBJECT, IS_ARRAY } from '@lowentry/utils';

var _excluded = ["store", "children"],
  _excluded2 = ["loading", "load"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LeRed = function () {
  var LeRed = {};
  try {
    var set = function set(key, value) {
      var ignoreOverrides = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var keyFirstChar = key.charAt(0);
      if (keyFirstChar === keyFirstChar.toLowerCase() && keyFirstChar !== keyFirstChar.toUpperCase()) {
        if (key === 'default' || key === 'version') {
          return;
        }
        if (key === 'set' || key === 'setAll') {
          console.error('tried to override LeRed["' + key + '"], which isn\'t allowed, to:');
          console.error(value);
          return;
        }
        if (ignoreOverrides !== true && key in LeRed) {
          console.warn('LeRed["' + key + '"] was overwritten, from:');
          console.warn(LeRed[key]);
          console.warn('to:');
          console.warn(value);
        }
        LeRed[key] = value;
      }
    };
    var setAll = function setAll(obj) {
      var ignoreOverrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var optionalSkipHasOwnPropertyCheck = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      LeUtils.each(obj, function (value, key) {
        set(key, value, ignoreOverrides);
      }, optionalSkipHasOwnPropertyCheck);
    };
    LeRed.set = function (key, value) {
      return set(key, value, true);
    };
    LeRed.setAll = function (obj) {
      var optionalSkipHasOwnPropertyCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return setAll(obj, true, optionalSkipHasOwnPropertyCheck);
    };
    setAll(ReactDOM);
    setAll(ReduxSaga);
    setAll({
      effects: _objectSpread({}, ReduxSagaEffects)
    });
    setAll(RTK);
    setAll(React);
    setAll(ReactRedux);
    LeRed.effects.delayFrames = function () {
      var frames = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return LeRed.effects.call(function () {
                return new Promise(function (resolve, reject) {
                  try {
                    LeUtils.setAnimationFrameTimeout(resolve, frames);
                  } catch (e) {
                    reject(e);
                  }
                });
              });
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    };
    LeRed.effects.interval = /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(callback, intervalMs) {
      var channel, stop;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            channel = LeRed.eventChannel(function (emitter) {
              var interval = setInterval(function () {
                emitter({});
              }, intervalMs);
              return function () {
                clearInterval(interval);
              };
            });
            stop = function stop() {
              try {
                if (channel !== null) {
                  channel.close();
                  channel = null;
                }
              } catch (e) {
                console.error(e);
              }
            };
          case 2:
            if (!(channel !== null)) {
              _context2.next = 28;
              break;
            }
            _context2.prev = 3;
            _context2.next = 6;
            return LeRed.effects.take(channel);
          case 6:
            _context2.next = 8;
            return callback(stop);
          case 8:
            _context2.next = 13;
            break;
          case 10:
            _context2.prev = 10;
            _context2.t0 = _context2["catch"](3);
            console.error(_context2.t0);
          case 13:
            _context2.prev = 13;
            _context2.prev = 14;
            _context2.next = 17;
            return LeRed.effects.cancelled();
          case 17:
            if (!_context2.sent) {
              _context2.next = 20;
              break;
            }
            channel.close();
            channel = null;
          case 20:
            _context2.next = 25;
            break;
          case 22:
            _context2.prev = 22;
            _context2.t1 = _context2["catch"](14);
            console.error(_context2.t1);
          case 25:
            return _context2.finish(13);
          case 26:
            _context2.next = 2;
            break;
          case 28:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 10, 13, 26], [14, 22]]);
    });
  } catch (e) {
    console.error(e);
  }
  var fixEqualsComparator = function fixEqualsComparator(equalsComparator, errorMessage) {
    if (ISSET(equalsComparator)) {
      if (typeof equalsComparator !== 'function') {
        console.error(errorMessage);
        console.error(equalsComparator);
        return FastDeepEqualReact;
      }
      return equalsComparator;
    }
    return FastDeepEqualReact;
  };
  var useCompareMemoize = function useCompareMemoize(value, equalsComparator) {
    var ref = React.useRef();
    if (!equalsComparator(value, ref.current)) {
      ref.current = value;
    }
    return ref.current;
  };
  LeRed.configureStore = function (storeData) {
    if (storeData.__lowentry_store__ === true) {
      return storeData;
    }
    if (ISSET(storeData.slices)) {
      storeData.reducer = storeData.slices;
      delete storeData.slices;
    }
    var sagaListeners = [];
    if (ISSET(storeData.reducer)) {
      var slices = storeData.reducer;
      if (_typeof(slices) === 'object') {
        if (slices.name || slices.__lowentry_unfinished_slice) {
          slices = [slices];
        } else {
          var slicesArray = [];
          LeUtils.each(slices, function (slice, index) {
            if (!slice.name) {
              slice.name = index;
            }
            slicesArray.push(slice);
          });
          slices = slicesArray;
        }
      }
      slices = ARRAY(slices);
      var initialState = {};
      var reducerArrays = {};
      LeUtils.each(slices, function (slice, index) {
        if (!slice.name) {
          slice.name = 'slice_' + index;
        }
        if (slice.__lowentry_unfinished_slice) {
          delete slice.__lowentry_unfinished_slice;
          slice = LeRed.createSlice(slice);
        }
        initialState[slice.name] = typeof slice.state === 'function' ? slice.state() : slice.state;
        LeUtils.each(slice.reducers, function (reducer, reducerName) {
          var fullReducerName = reducerName.startsWith('lowentrystore/') ? reducerName.substring('lowentrystore/'.length) : slice.name + '/' + reducerName;
          if (typeof reducerArrays[fullReducerName] === 'undefined') {
            reducerArrays[fullReducerName] = [];
          }
          reducerArrays[fullReducerName].push(reducer);
        });
        LeUtils.each(slice.sagaListeners, function (sagaListener, reducerName) {
          LeUtils.each(LeUtils.flattenArray(sagaListener), function (listener) {
            try {
              sagaListeners.push(listener());
            } catch (e) {
              console.error('an error was thrown by your saga code, in slice "' + slice.name + '", action "' + reducerName + '":');
              console.error(e);
            }
          });
        });
      });
      var reducers = {};
      LeUtils.each(reducerArrays, function (reducerArray, reducerName) {
        reducerArray = LeUtils.flattenArray(reducerArray);
        if (reducerArray.length <= 0) {
          reducers[reducerName] = reducerArray[0];
        } else {
          reducers[reducerName] = function () {
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            LeUtils.each(reducerArray, function (reducer) {
              try {
                reducer.apply(void 0, args);
              } catch (e) {
                console.error(e);
              }
            });
          };
        }
      });
      storeData.reducer = RTK.createSlice({
        name: 'lowentrystore',
        initialState: initialState,
        reducers: reducers
      }).reducer;
    }
    if (ISSET(storeData.state)) {
      storeData.preloadedState = storeData.state;
      delete storeData.state;
    }
    if (ISSET(storeData.preloadedState)) {
      storeData.preloadedState = {
        reducer: storeData.preloadedState
      };
    }
    var middleware = ARRAY(storeData.middleware);
    var sagaMiddleware = null;
    if (sagaListeners.length > 0) {
      sagaMiddleware = ReduxSaga["default"]();
      middleware.push(sagaMiddleware);
    }
    storeData.middleware = function (getDefaultMiddleware) {
      var _getDefaultMiddleware;
      return (_getDefaultMiddleware = getDefaultMiddleware()).concat.apply(_getDefaultMiddleware, _toConsumableArray(middleware));
    };
    var store = RTK.configureStore(storeData);
    store.__lowentry_store__ = true;
    store.state = function () {
      return store.getState().reducer;
    };
    var dispatch = store.dispatch;
    // noinspection JSValidateTypes
    store.dispatch = function (action) {
      action.__lowentry_dispatch__ = true;
      if (STRING(action.type).startsWith('lowentrystore/lowentryaction/')) {
        action.__lowentry_dispatch_result__ = [];
      } else {
        delete action.__lowentry_dispatch_result__;
      }
      dispatch(action);
      var result = action.__lowentry_dispatch_result__;
      delete action.__lowentry_dispatch_result__;
      delete action.__lowentry_dispatch__;
      return result;
    };
    if (sagaMiddleware !== null) {
      sagaMiddleware.run(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return ReduxSagaEffects.all(sagaListeners);
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
    }
    return store;
  };
  LeRed.createAction = function (id) {
    return RTK.createAction('lowentrystore/lowentryaction/' + id);
  };
  LeRed.createSelector = function (selectorsGenerator) {
    return function (stateOfSlice) {
      var state = this;
      var selectors = selectorsGenerator.apply(state, [stateOfSlice]);
      var selectorArgs = [];
      for (var i = 0; i < selectors.length - 1; i++) {
        var selectorsEntry = selectors[i];
        if (typeof selectorsEntry === 'function') {
          selectorsEntry = selectorsEntry.apply(state, [state]);
        }
        selectorArgs.push(selectorsEntry);
      }
      var finalSelector = selectors[selectors.length - 1];
      if (typeof finalSelector === 'function') {
        finalSelector = finalSelector.apply(state, selectorArgs);
      }
      return finalSelector;
    };
  };
  LeRed.createCachedSelector = function (selectorsGenerator, equalsComparator) {
    equalsComparator = fixEqualsComparator(equalsComparator, 'LeRed.createCachedSelector() was given an invalid comparator:');
    if (equalsComparator === false) {
      return;
    }
    var previousSelectorArgs = null;
    var previousFinalSelectorResult = null;
    return function (stateOfSlice) {
      var state = this;
      var selectors = selectorsGenerator.apply(state, [stateOfSlice]);
      var selectorArgs = [];
      for (var i = 0; i < selectors.length - 1; i++) {
        var selectorsEntry = selectors[i];
        if (typeof selectorsEntry === 'function') {
          selectorsEntry = selectorsEntry.apply(state, [state]);
        }
        selectorArgs.push(selectorsEntry);
      }
      var finalSelector = selectors[selectors.length - 1];
      if (typeof finalSelector === 'function') {
        if (equalsComparator(previousSelectorArgs, selectorArgs)) {
          finalSelector = previousFinalSelectorResult;
        } else {
          finalSelector = finalSelector.apply(state, selectorArgs);
          previousSelectorArgs = selectorArgs;
          previousFinalSelectorResult = finalSelector;
        }
      }
      return finalSelector;
    };
  };
  LeRed.createSlice = function (slice) {
    if (Array.isArray(slice)) {
      var e = new Error('the given slice is an array (instead of an object)');
      console.error('an error was thrown by your LeRed.createSlice(...) code:');
      console.error(e);
      throw e;
    }
    if (slice.name) {
      var actions = {};
      var reducers = {};
      var sagas = {};
      var sagaListeners = {};
      LeUtils.each(slice.actions, function (reducer, reducerNames) {
        LeUtils.each(reducerNames.split(','), function (reducerName) {
          if (reducerName.length <= 0) {
            return;
          }
          var reducerAction = RTK.createAction((reducerName.startsWith('lowentrystore/') ? '' : 'lowentrystore/' + slice.name + '/') + reducerName);
          actions[reducerName] = reducerAction;
          LeUtils.each(LeUtils.flattenArray(reducer), function (reducer) {
            if (LeUtils.isGeneratorFunction(reducer)) {
              var sagaListener = /*#__PURE__*/_regeneratorRuntime.mark(function sagaListener() {
                return _regeneratorRuntime.wrap(function sagaListener$(_context5) {
                  while (1) switch (_context5.prev = _context5.next) {
                    case 0:
                      _context5.next = 2;
                      return ReduxSagaEffects.takeEvery(reducerAction, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(action) {
                        var promiseResolve, promiseReject, promise, result;
                        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                          while (1) switch (_context4.prev = _context4.next) {
                            case 0:
                              promiseResolve = null;
                              promiseReject = null;
                              _context4.prev = 2;
                              if (action.__lowentry_dispatch__ === true) {
                                promise = new Promise(function (resolve, reject) {
                                  promiseResolve = resolve;
                                  promiseReject = reject;
                                });
                                if (Array.isArray(action.__lowentry_dispatch_result__)) {
                                  if (typeof promise !== 'undefined') {
                                    action.__lowentry_dispatch_result__.push(promise);
                                  }
                                } else {
                                  action.__lowentry_dispatch_result__ = promise;
                                }
                              }
                              _context4.next = 6;
                              return reducer.apply(slice, [action.payload]);
                            case 6:
                              result = _context4.sent;
                              if (promiseResolve !== null) {
                                promiseResolve(result);
                              }
                              _context4.next = 15;
                              break;
                            case 10:
                              _context4.prev = 10;
                              _context4.t0 = _context4["catch"](2);
                              console.error('an error was thrown by your LeRed.createSlice(...) code, by slice "' + slice.name + '", action "' + reducerName + '":');
                              console.error(_context4.t0);
                              if (promiseReject !== null) {
                                try {
                                  promiseReject(_context4.t0);
                                } catch (e2) {
                                  console.error(e2);
                                }
                              }
                            case 15:
                            case "end":
                              return _context4.stop();
                          }
                        }, _callee4, null, [[2, 10]]);
                      }));
                    case 2:
                    case "end":
                      return _context5.stop();
                  }
                }, sagaListener);
              });
              if (ISSET(sagas[reducerName])) {
                sagas[reducerName].push(reducer);
              } else {
                sagas[reducerName] = [reducer];
              }
              if (ISSET(sagaListeners[reducerName])) {
                sagaListeners[reducerName].push(sagaListener);
              } else {
                sagaListeners[reducerName] = [sagaListener];
              }
            } else {
              var reducerFunction = function reducerFunction(state, action) {
                try {
                  var result = reducer.apply(state, [state[slice.name], action.payload]);
                  if (action.__lowentry_dispatch__ === true) {
                    if (Array.isArray(action.__lowentry_dispatch_result__)) {
                      if (typeof result !== 'undefined') {
                        action.__lowentry_dispatch_result__.push(result);
                      }
                    } else {
                      action.__lowentry_dispatch_result__ = result;
                    }
                  }
                } catch (e) {
                  console.error('an error was thrown by your LeRed.createSlice(...) code, by slice "' + slice.name + '", action "' + reducerName + '":');
                  console.error(e);
                }
              };
              if (ISSET(reducers[reducerName])) {
                reducers[reducerName].push(reducerFunction);
              } else {
                reducers[reducerName] = [reducerFunction];
              }
            }
          });
        });
      });
      slice.actions = actions;
      slice.reducers = reducers;
      slice.sagas = sagas;
      slice.sagaListeners = sagaListeners;
      var selectors = {};
      LeUtils.each(slice.selectors, function (selector, selectorName) {
        selectors[selectorName] = function (state) {
          try {
            return selector.apply(state, [state[slice.name]]);
          } catch (e) {
            console.error('an error was thrown by your LeRed.createSlice(...) code, by slice "' + slice.name + '", selector "' + selectorName + '":');
            console.error(e);
            throw e;
          }
        };
      });
      slice.selectors = selectors;
      var getters = {};
      LeUtils.each(slice.getters, function (getter, getterName) {
        getters[getterName] = function () {
          try {
            var selector = getter.apply(void 0, arguments);
            return function (state) {
              try {
                return selector.apply(state, [state[slice.name]]);
              } catch (e) {
                console.error('an error was thrown by your LeRed.createSlice(...) code, by slice "' + slice.name + '", getter "' + getterName + '":');
                console.error(e);
                throw e;
              }
            };
          } catch (e) {
            console.error('an error was thrown by your LeRed.createSlice(...) code, by slice "' + slice.name + '", getter "' + getterName + '":');
            console.error(e);
            throw e;
          }
        };
      });
      slice.getters = getters;
      return slice;
    } else {
      slice.__lowentry_unfinished_slice = true;
      return slice;
    }
  };
  LeRed.createFastSlice = function (slice) {
    if (Array.isArray(slice)) {
      var e = new Error('the given slice is an array (instead of an object)');
      console.error('an error was thrown by your LeRed.createFastSlice(...) code:');
      console.error(e);
      throw e;
    }
    var actions = {};
    LeUtils.each(slice.actions, function (reducer, reducerName) {
      actions[reducerName] = function () {
        for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          params[_key2] = arguments[_key2];
        }
        return reducer.apply(slice, [slice.state].concat(params));
      };
    });
    slice.actions = actions;
    var selectors = {};
    LeUtils.each(slice.selectors, function (selector, selectorName) {
      selectors[selectorName] = function () {
        return selector.apply(slice, [slice.state]);
      };
    });
    slice.selectors = new Proxy(selectors, {
      get: function get(target, key) {
        return key in target ? target[key]() : undefined;
      }
    });
    var getters = {};
    LeUtils.each(slice.getters, function (selector, selectorName) {
      getters[selectorName] = function () {
        for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          params[_key3] = arguments[_key3];
        }
        return selector.apply(slice, [slice.state].concat(params));
      };
    });
    slice.getters = getters;
    return slice;
  };
  LeRed.current = function (obj) {
    try {
      return RTK.current(obj);
    } catch (e) {}
    return obj;
  };
  LeRed.useConfigureStore = function (storeData) {
    return LeRed.useMemo(function () {
      return LeRed.configureStore(storeData);
    }, [storeData]);
  };
  LeRed.useSelector = function (selector, equalsComparator) {
    if (typeof selector !== 'function') {
      console.error('LeRed.useSelector() was given an invalid selector:');
      console.error(selector);
      selector = function selector() {};
    }
    equalsComparator = fixEqualsComparator(equalsComparator, 'LeRed.useSelector() was given an invalid comparator:');
    return ReactRedux.useSelector(selector, equalsComparator);
  };
  LeRed.useEffect = function (callable, comparingValues, equalsComparator) {
    equalsComparator = fixEqualsComparator(equalsComparator, 'LeRed.useEffect() was given an invalid comparator:');
    comparingValues = ARRAY(comparingValues);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    comparingValues = comparingValues.map(function (value) {
      return useCompareMemoize(value, equalsComparator);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useEffect(callable, comparingValues);
  };
  LeRed.useEffectInterval = function (callable, comparingValues, intervalMs, fireImmediately, equalsComparator) {
    return LeRed.useEffect(function () {
      return LeUtils.setInterval(callable, intervalMs, fireImmediately).remove;
    }, [comparingValues, equalsComparator]);
  };
  LeRed.useEffectAnimationFrameInterval = function (callable, comparingValues, intervalFrames, fireImmediately, equalsComparator) {
    return LeRed.useEffect(function () {
      return LeUtils.setAnimationFrameInterval(callable, intervalFrames, fireImmediately).remove;
    }, [comparingValues, equalsComparator]);
  };
  LeRed.useEffectGenerator = function (callable, comparingValues, intervalMs, fireImmediately, equalsComparator) {
    return LeRed.useEffect(function () {
      var stop = false;
      _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iterator, _step, promise;
        return _regeneratorRuntime.wrap(function _callee5$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(callable());
              _context6.prev = 1;
              _iterator.s();
            case 3:
              if ((_step = _iterator.n()).done) {
                _context6.next = 13;
                break;
              }
              promise = _step.value;
              if (!stop) {
                _context6.next = 7;
                break;
              }
              return _context6.abrupt("return");
            case 7:
              _context6.next = 9;
              return promise;
            case 9:
              if (!stop) {
                _context6.next = 11;
                break;
              }
              return _context6.abrupt("return");
            case 11:
              _context6.next = 3;
              break;
            case 13:
              _context6.next = 18;
              break;
            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6["catch"](1);
              _iterator.e(_context6.t0);
            case 18:
              _context6.prev = 18;
              _iterator.f();
              return _context6.finish(18);
            case 21:
            case "end":
              return _context6.stop();
          }
        }, _callee5, null, [[1, 15, 18, 21]]);
      }))();
      return function () {
        stop = true;
      };
    }, [comparingValues, equalsComparator]);
  };
  LeRed.useEffectGeneratorLoop = function (callable, comparingValues, intervalMs, fireImmediately, equalsComparator) {
    return LeRed.useEffect(function () {
      var stop = false;
      _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _iterator2, _step2, promise;
        return _regeneratorRuntime.wrap(function _callee6$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (stop) {
                _context7.next = 24;
                break;
              }
              _iterator2 = _createForOfIteratorHelper(callable());
              _context7.prev = 2;
              _iterator2.s();
            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context7.next = 14;
                break;
              }
              promise = _step2.value;
              if (!stop) {
                _context7.next = 8;
                break;
              }
              return _context7.abrupt("return");
            case 8:
              _context7.next = 10;
              return promise;
            case 10:
              if (!stop) {
                _context7.next = 12;
                break;
              }
              return _context7.abrupt("return");
            case 12:
              _context7.next = 4;
              break;
            case 14:
              _context7.next = 19;
              break;
            case 16:
              _context7.prev = 16;
              _context7.t0 = _context7["catch"](2);
              _iterator2.e(_context7.t0);
            case 19:
              _context7.prev = 19;
              _iterator2.f();
              return _context7.finish(19);
            case 22:
              _context7.next = 0;
              break;
            case 24:
            case "end":
              return _context7.stop();
          }
        }, _callee6, null, [[2, 16, 19, 22]]);
      }))();
      return function () {
        stop = true;
      };
    }, [comparingValues, equalsComparator]);
  };
  LeRed.useEffectShutdown = function (callable, comparingValues, equalsComparator) {
    return LeRed.useEffect(function () {
      var run = function run() {
        callable();
      };
      if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', run, {
          capture: true
        });
      }
      return function () {
        if (typeof window !== 'undefined') {
          window.removeEventListener('beforeunload', run, {
            capture: true
          });
        }
        run();
      };
    }, [comparingValues, equalsComparator]);
  };
  LeRed.useEffectPageFocusLost = function (callable, comparingValues, equalsComparator) {
    var events = ['pagehide', 'freeze', 'blur', 'visibilitychange'];
    return LeRed.useEffect(function () {
      if (typeof window === 'undefined') {
        return;
      }
      var run = function run() {
        if (typeof document === 'undefined') {
          return;
        }
        if (document.visibilityState !== 'hidden' && document.hasFocus()) {
          return;
        }
        callable();
      };
      events.forEach(function (type) {
        return window.addEventListener(type, run, {
          capture: true
        });
      });
      return function () {
        events.forEach(function (type) {
          return window.removeEventListener(type, run, {
            capture: true
          });
        });
      };
    }, [comparingValues, equalsComparator]);
  };
  LeRed.memo = function (component, equalsComparator) {
    equalsComparator = fixEqualsComparator(equalsComparator, 'LeRed.memo() was given an invalid comparator:');
    return /*#__PURE__*/React.memo(component, equalsComparator);
  };
  LeRed.useMemo = function (callable, comparingValues, equalsComparator) {
    equalsComparator = fixEqualsComparator(equalsComparator, 'LeRed.useMemo() was given an invalid comparator:');
    comparingValues = ARRAY(comparingValues);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    comparingValues = comparingValues.map(function (value) {
      return useCompareMemoize(value, equalsComparator);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useMemo(callable, comparingValues);
  };
  LeRed.useCallback = function (callable, comparingValues, equalsComparator) {
    equalsComparator = fixEqualsComparator(equalsComparator, 'LeRed.useCallback() was given an invalid comparator:');
    comparingValues = ARRAY(comparingValues);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    comparingValues = comparingValues.map(function (value) {
      return useCompareMemoize(value, equalsComparator);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(callable, comparingValues);
  };
  LeRed.usePrevious = function (value, initialValue) {
    var ref = LeRed.useRef(initialValue);
    LeRed.useEffect(function () {
      ref.current = value;
    }, [value]);
    return ref.current;
  };
  LeRed.useFont = function (font) {
    font = '12px ' + STRING(font).trim();
    var _LeRed$useState = LeRed.useState(false),
      _LeRed$useState2 = _slicedToArray(_LeRed$useState, 2),
      hasFont = _LeRed$useState2[0],
      setHasFont = _LeRed$useState2[1];
    LeRed.useEffect(function () {
      if (!hasFont) {
        var _document;
        if (typeof window === 'undefined' || !ISSET((_document = document) === null || _document === void 0 || (_document = _document.fonts) === null || _document === void 0 ? void 0 : _document.check)) {
          setHasFont(true);
          return;
        }
        var handler = setInterval(function () {
          try {
            if (document.fonts.check(font)) {
              clearInterval(handler);
              setHasFont(true);
            }
          } catch (e) {
            console.error(e);
            clearInterval(handler);
            setHasFont(true);
          }
        }, 30);
      }
    }, [hasFont]);
    return hasFont;
  };

  /**
   * Adds a <script> tag to the <head> of the document.
   * Only for development and testing purposes.
   *
   * @param {string} url The URL of the js file to include.
   * @param {object} props Additional props of the <script> tag.
   */
  LeRed.useScript = function (url) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return LeRed.useEffect(function () {
      if (typeof window === 'undefined' || !document) {
        return;
      }
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      LeUtils.each(props, function (value, key) {
        script.setAttribute(key, value);
      });
      document.head.appendChild(script);
      return function () {
        return document.head.removeChild(script);
      };
    }, [url, props]);
  };
  LeRed.mergeRefs = function () {
    for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      refs[_key4] = arguments[_key4];
    }
    refs = LeUtils.flattenArray(refs);
    if (!refs) {
      return null;
    }
    var newRefs = [];
    LeUtils.each(refs, function (ref) {
      if (ref) {
        newRefs.push(ref);
      }
    });
    refs = newRefs;
    if (refs.length <= 0) {
      return null;
    }
    if (refs.length === 1) {
      return refs[0];
    }
    return function (inst) {
      LeUtils.each(refs, function (ref) {
        try {
          if (typeof ref === 'function') {
            ref(inst);
          } else if (ref) {
            ref.current = inst;
          }
        } catch (e) {
          console.error(e);
        }
      });
    };
  };
  LeRed.useTriggerable = function (event) {
    var _LeRed$useState3 = LeRed.useState([null, LeUtils.uniqueId()]),
      _LeRed$useState4 = _slicedToArray(_LeRed$useState3, 2),
      _LeRed$useState4$ = _slicedToArray(_LeRed$useState4[0], 2),
      value = _LeRed$useState4$[0];
      _LeRed$useState4$[1];
      var setValue = _LeRed$useState4[1];
    LeRed.useEffect(function () {
      if (typeof window === 'undefined') {
        return;
      }
      var callback = function callback(e) {
        setValue([e === null || e === void 0 ? void 0 : e.detail, LeUtils.uniqueId()]);
      };
      var eventName = 'lowentrytriggerable_' + event;
      window.addEventListener(eventName, callback);
      return function () {
        return window.removeEventListener(eventName, callback);
      };
    }, []);
    return value;
  };
  LeRed.trigger = function (event, value) {
    if (typeof window === 'undefined') {
      return;
    }
    var eventName = 'lowentrytriggerable_' + event;
    window.dispatchEvent(new CustomEvent(eventName, {
      detail: value
    }));
  };

  /**
   * A useState() hook that automatically resets to the defaultValue after the given duration.
   *
   * Example:
   *
   * ```js
   * const [value, setValue] = LeRed.useTempState(true, 2000);
   * // somewhere in your code:
   * setValue(false); // value is now false, after 2 seconds it will be reset to true
   * ```
   *
   * Repeated calls cause the timer to reset, meaning each set value will always remain for the full given duration.
   */
  LeRed.useTempState = function (defaultValue, duration) {
    var _LeRed$useState5 = LeRed.useState(defaultValue),
      _LeRed$useState6 = _slicedToArray(_LeRed$useState5, 2),
      value = _LeRed$useState6[0],
      setValue = _LeRed$useState6[1];
    var timeoutHandle = LeRed.useRef(null);
    return [value, function (newValue) {
      if (timeoutHandle.current) {
        clearTimeout(timeoutHandle.current);
      }
      setValue(newValue);
      timeoutHandle.current = setTimeout(function () {
        timeoutHandle.current = null;
        setValue(defaultValue);
      }, duration);
    }];
  };

  /**
   * Allows you to listen to the browser history events (forwards, backwards) and execute a callback on those events.
   *
   * You pass 2 functions to it (the callbacks), and it also provides 2 functions (for manually going forwards and backwards).
   *
   * Usage:
   *
   * ```js
   * const [goForwards, goBackwards] = LeRed.useHistory(() => console.log('has gone forwards'), () => console.log('has gone backwards'));
   * ```
   */
  LeRed.useHistory = function () {
    var historyStateListeners = [];
    if (typeof window !== 'undefined') {
      window.addEventListener('popstate', function () {
        var _historyStateListener;
        (_historyStateListener = historyStateListeners.pop()) === null || _historyStateListener === void 0 || _historyStateListener.callback();
      });
    }
    var addListener = function addListener(callback) {
      var id = LeUtils.uniqueId();
      historyStateListeners.push({
        id: id,
        callback: callback
      });
      return id;
    };
    var removeListener = function removeListener(id) {
      if (!id) {
        return;
      }
      historyStateListeners = historyStateListeners.filter(function (listener) {
        return listener.id !== id;
      });
    };
    return function (onForward, onBack) {
      var remaining = LeRed.useRef(0);
      var id = LeRed.useRef(null);
      var goBack = LeRed.useCallback(function () {
        if (remaining.current <= 0) {
          return;
        }
        remaining.current--;
        if (remaining.current === 0) {
          if (id.current) {
            removeListener(id.current);
          }
          id.current = null;
        }
        onBack();
      }, [onBack]);
      return [function () /** do **/
      {
        LeRed.navigate('#');
        remaining.current++;
        if (remaining.current === 1) {
          if (id.current) {
            removeListener(id.current);
          }
          id.current = addListener(goBack);
        }
        onForward();
      }, function () /** undo **/
      {
        if (remaining.current > 0) {
          LeRed.navigate(-1);
        }
      }];
    };
  }();

  /**
   * Similar to {@link LeRed.useHistory}, but this is specifically for toggling a boolean state between true and false. For example, for a modal, which you'd like to be closed when the user goes back in history.
   *
   * Example:
   *
   * ```js
   * const [isModalOpen, openModal, closeModal] = LeRed.useHistoryState(false); // you'd open it programmatically using openModal(), afterwards, if the user goes back in history, it will close again
   * ```
   *
   * or, if you'd like it to be true by default:
   *
   * ```js
   * const [isModalOpen, openModal, closeModal] = LeRed.useHistoryState(true); // you'd close it programmatically using closeModal(), afterwards, if the user goes back in history, it will open again
   * ```
   */
  LeRed.useHistoryState = function (initialState) {
    var _LeRed$useState7 = LeRed.useState(!!initialState),
      _LeRed$useState8 = _slicedToArray(_LeRed$useState7, 2),
      state = _LeRed$useState8[0],
      setState = _LeRed$useState8[1];
    var _LeRed$useHistory = LeRed.useHistory(function () {
        return setState(!initialState);
      }, function () {
        return setState(!!initialState);
      }),
      _LeRed$useHistory2 = _slicedToArray(_LeRed$useHistory, 2),
      forwards = _LeRed$useHistory2[0],
      backwards = _LeRed$useHistory2[1];
    if (!!initialState) {
      return [state, backwards, forwards];
    }
    return [state, forwards, backwards];
  };

  /**
   * Allows you to easily create an <pre><img></pre> url and onError handler that will automatically retry loading the image if it fails.
   */
  LeRed.useRetryingImageUrl = function (url, options) {
    url = STRING(url);
    var urlHasQ = url.includes('?');
    var _LeRed$useState9 = LeRed.useState(url),
      _LeRed$useState10 = _slicedToArray(_LeRed$useState9, 2),
      imageUrl = _LeRed$useState10[0],
      setImageUrl = _LeRed$useState10[1];
    var retries = LeRed.useRef(0);
    var timeout = LeRed.useRef({
      remove: function remove() {
        return undefined;
      }
    });
    LeRed.useEffect(function () {
      timeout.current.remove();
      retries.current = 0;
      setImageUrl(url);
    }, [url]);
    var onImageLoadError = LeRed.useCallback(function () {
      if (retries.current < INT_LAX_ANY(options === null || options === void 0 ? void 0 : options.retries, 30)) {
        var defaultDelay = 100 + 50 * retries.current;
        timeout.current.remove();
        timeout.current = LeUtils.setTimeout(function () {
          setImageUrl(url + (urlHasQ ? '&' : '?') + ((options === null || options === void 0 ? void 0 : options.queryParam) || 'lowentryretryingimgversion') + '=' + retries.current++);
        }, typeof (options === null || options === void 0 ? void 0 : options.delay) === 'function' ? INT_LAX_ANY(options === null || options === void 0 ? void 0 : options.delay(retries.current), defaultDelay) : INT_LAX_ANY(options === null || options === void 0 ? void 0 : options.delay, defaultDelay));
      }
    }, [url, options]);
    var onImageLoadErrorIgnored = LeRed.useCallback(function () {}, []);
    if (!url) {
      return [url, onImageLoadErrorIgnored];
    }
    return [imageUrl, onImageLoadError];
  };

  /**
   * Allows you to easily convert promises to react hooks.
   *
   * The given callable should return promises. The returned promises can be an array, an object, or even a single promise. The returned data of this hook will match the promises it has operated on.
   *
   * The given comparingValues can be anything, this is used to detect whether the given promises have changed or not, and so whether new promises have to be generated and executed again.
   */
  LeRed.usePromises = function (callable, comparingValues) {
    var comparingValuesClone = LeUtils.clone(comparingValues);
    var comparingValuesRef = LeRed.useRef(comparingValuesClone);
    var latestComparingValuesRef = LeRed.useRef();
    latestComparingValuesRef.current = comparingValuesClone;
    var _LeRed$useState11 = LeRed.useState(null),
      _LeRed$useState12 = _slicedToArray(_LeRed$useState11, 2),
      data = _LeRed$useState12[0],
      setData = _LeRed$useState12[1];
    var _LeRed$useState13 = LeRed.useState(true),
      _LeRed$useState14 = _slicedToArray(_LeRed$useState13, 2),
      loading = _LeRed$useState14[0],
      setLoading = _LeRed$useState14[1];
    var _LeRed$useState15 = LeRed.useState(null),
      _LeRed$useState16 = _slicedToArray(_LeRed$useState15, 2),
      error = _LeRed$useState16[0],
      setError = _LeRed$useState16[1];
    LeRed.useEffect(function () {
      setLoading(true);
      setData(null);
      setError(null);
      try {
        var promises = callable();
        var promisesIsObject = IS_OBJECT(promises) && typeof (promises === null || promises === void 0 ? void 0 : promises.then) !== 'function';
        var promisesIsArray = IS_ARRAY(promises);
        var promisesKeyed = [];
        if (promisesIsObject || promisesIsArray) {
          LeUtils.each(promises, function (promise, key) {
            promisesKeyed.push({
              promise: promise,
              key: key
            });
          });
        } else {
          promisesKeyed.push({
            promise: promises,
            key: undefined
          });
        }
        var wrappedPromises = [];
        LeUtils.each(promisesKeyed, function (_ref3) {
          var promise = _ref3.promise,
            key = _ref3.key;
          wrappedPromises.push(promise.then(/*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(result) {
              return _regeneratorRuntime.wrap(function _callee7$(_context8) {
                while (1) switch (_context8.prev = _context8.next) {
                  case 0:
                    return _context8.abrupt("return", {
                      result: result,
                      key: key
                    });
                  case 1:
                  case "end":
                    return _context8.stop();
                }
              }, _callee7);
            }));
            return function (_x) {
              return _ref4.apply(this, arguments);
            };
          }()));
        });
        Promise.all(wrappedPromises).then(function (resultObjects) {
          var _resultObjects$pop;
          if (promisesIsObject) {
            var results = {};
            LeUtils.each(resultObjects, function (_ref5) {
              var result = _ref5.result,
                key = _ref5.key;
              results[key] = result;
            });
            return results;
          } else if (promisesIsArray) {
            var _results = [];
            LeUtils.each(resultObjects, function (_ref6) {
              var result = _ref6.result,
                key = _ref6.key;
              _results[key] = result;
            });
            return _results;
          }
          return (_resultObjects$pop = resultObjects.pop()) === null || _resultObjects$pop === void 0 ? void 0 : _resultObjects$pop.result;
        }).then(function (results) {
          if (!LeUtils.equals(latestComparingValuesRef.current, comparingValuesClone)) {
            // canceled
            return;
          }
          comparingValuesRef.current = comparingValuesClone;
          setLoading(false);
          setData(results);
          setError(null);
        })["catch"](function (error) {
          if (!LeUtils.equals(latestComparingValuesRef.current, comparingValuesClone)) {
            // canceled
            return;
          }
          comparingValuesRef.current = comparingValuesClone;
          setLoading(false);
          setData(null);
          setError(LeUtils.purgeErrorMessage(error));
        });
        return function () {
          LeUtils.each(wrappedPromises, function (promise) {
            try {
              var _promise$cancel;
              promise === null || promise === void 0 || (_promise$cancel = promise.cancel) === null || _promise$cancel === void 0 || _promise$cancel.call(promise);
            } catch (e) {
              console.error('Failed to cancel the given promise:', e);
            }
            try {
              var _promise$remove;
              promise === null || promise === void 0 || (_promise$remove = promise.remove) === null || _promise$remove === void 0 || _promise$remove.call(promise);
            } catch (e) {
              console.error('Failed to remove the given promise:', e);
            }
          });
        };
      } catch (error) {
        LeUtils.setAnimationFrameTimeout(function () {
          if (!LeUtils.equals(latestComparingValuesRef.current, comparingValuesClone)) {
            // canceled
            return;
          }
          comparingValuesRef.current = comparingValuesClone;
          setLoading(false);
          setData(null);
          setError(LeUtils.purgeErrorMessage(error));
        });
      }
    }, [comparingValuesClone]);
    if (!LeUtils.equals(comparingValuesRef.current, comparingValuesClone)) {
      return [null, true, null];
    }
    return [data, loading, error];
  };

  /**
   * Allows you to easily obtain external data.
   */
  LeRed.useExternal = function (url, options, responseFunction) {
    return LeRed.usePromises(function () {
      var createFetch = function createFetch(urlString) {
        return LeUtils.fetch(STRING(urlString), _objectSpread({
          retries: 3
        }, options !== null && options !== void 0 ? options : {})).then(/*#__PURE__*/function () {
          var _ref7 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(response) {
            var data;
            return _regeneratorRuntime.wrap(function _callee8$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return responseFunction(response);
                case 2:
                  data = _context9.sent;
                  if (!(typeof (options === null || options === void 0 ? void 0 : options.verify) === 'function')) {
                    _context9.next = 6;
                    break;
                  }
                  _context9.next = 6;
                  return options.verify(data, response);
                case 6:
                  return _context9.abrupt("return", data);
                case 7:
                case "end":
                  return _context9.stop();
              }
            }, _callee8);
          }));
          return function (_x2) {
            return _ref7.apply(this, arguments);
          };
        }());
      };
      if (IS_OBJECT(url)) {
        var promises = {};
        LeUtils.each(url, function (urlString, key) {
          promises[key] = createFetch(urlString);
        });
        return promises;
      }
      if (IS_ARRAY(url)) {
        var _promises = [];
        LeUtils.each(url, function (urlString) {
          _promises.push(createFetch(urlString));
        });
        return _promises;
      }
      return createFetch(url);
    }, [url, options, responseFunction]);
  };

  /**
   * Allows you to easily obtain external JSON data.
   */
  LeRed.useExternalJson = function (url, options) {
    var responseFunction = LeRed.useCallback(function (response) {
      return response.json();
    }, []);
    return LeRed.useExternal(url, options, responseFunction);
  };

  /**
   * Allows you to easily obtain external Blob data.
   */
  LeRed.useExternalBlob = function (url, options) {
    var responseFunction = LeRed.useCallback(function (response) {
      return response.blob();
    }, []);
    return LeRed.useExternal(url, options, responseFunction);
  };

  /**
   * Allows you to easily obtain external ArrayBuffer data.
   */
  LeRed.useExternalArrayBuffer = function (url, options) {
    var responseFunction = LeRed.useCallback(function (response) {
      return response.arrayBuffer();
    }, []);
    return LeRed.useExternal(url, options, responseFunction);
  };

  /**
   * Allows you to easily obtain external string data.
   */
  LeRed.useExternalString = function (url, options) {
    var responseFunction = LeRed.useCallback(function (response) {
      return response.text();
    }, []);
    return LeRed.useExternal(url, options, responseFunction);
  };

  /**
   * Allows you to easily obtain external form data.
   */
  LeRed.useExternalFormData = function (url, options) {
    var responseFunction = LeRed.useCallback(function (response) {
      return response.formData();
    }, []);
    return LeRed.useExternal(url, options, responseFunction);
  };
  LeRed.Root = LeRed.memo(function (_ref8) {
    var store = _ref8.store,
      children = _ref8.children,
      other = _objectWithoutProperties(_ref8, _excluded);
    if (ISSET(store)) {
      store = LeRed.configureStore(store);
      return /*#__PURE__*/React.createElement(ReactRedux.Provider, _extends({
        store: store
      }, other), children);
    }
    return children;
  });
  LeRed.PreloadComponent = function (load) {
    if (typeof window !== 'undefined') {
      var promise = load(); // start loading already, before it's being rendered in React
      return function () {
        return promise;
      };
    }
    return load;
  };
  LeRed.LoadComponent = LeRed.memo(function (_ref9) {
    var loading = _ref9.loading,
      load = _ref9.load,
      other = _objectWithoutProperties(_ref9, _excluded2);
    var _LeRed$useState17 = LeRed.useState(loading !== null && loading !== void 0 ? loading : null),
      _LeRed$useState18 = _slicedToArray(_LeRed$useState17, 2),
      Component = _LeRed$useState18[0],
      setComponent = _LeRed$useState18[1];
    LeRed.useEffect(function () {
      _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var LoadedComponent;
        return _regeneratorRuntime.wrap(function _callee9$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(typeof load === 'function')) {
                _context10.next = 6;
                break;
              }
              _context10.next = 3;
              return load();
            case 3:
              _context10.t0 = _context10.sent;
              _context10.next = 9;
              break;
            case 6:
              _context10.next = 8;
              return load;
            case 8:
              _context10.t0 = _context10.sent;
            case 9:
              LoadedComponent = _context10.t0;
              if (LoadedComponent) {
                _context10.next = 13;
                break;
              }
              setComponent(null);
              return _context10.abrupt("return");
            case 13:
              setComponent(/*#__PURE__*/React.createElement(LoadedComponent, other));
            case 14:
            case "end":
              return _context10.stop();
          }
        }, _callee9);
      }))();
    }, []);
    return Component;
  });
  if (typeof Proxy === 'undefined') {
    return LeRed;
  }
  return new Proxy(LeRed, {
    set: function set(target, key, value) {
      LeRed.set(key, value);
      return true;
    }
  });
}();

export { LeRed };
//# sourceMappingURL=index.js.map
